import { StepProps } from 'antd';
import { AppDotWithNumberStepsStyled, Centered } from './AppDotWithNumberSteps.styled';

export type AppDotWithNumberStepsProps = {
    current: number;
    stepsCount: number;
    centered?: boolean;
    accessibilityLabel?: string;
};
const getNumberSteps: (stepsCount: AppDotWithNumberStepsProps['stepsCount']) => StepProps[] = (
    stepsCount,
) => Array(stepsCount).fill({});

export const AppDotWithNumberSteps = ({
    current,
    stepsCount,
    centered = true,
    accessibilityLabel,
}: AppDotWithNumberStepsProps) => {
    const numberSteps = getNumberSteps(stepsCount);
    const maxWidth = stepsCount * 26 + (stepsCount - 1 || 0) * 40;

    const content = (
        <AppDotWithNumberStepsStyled
            maxWidth={centered ? maxWidth : undefined}
            responsive={false}
            labelPlacement="vertical"
            direction="horizontal"
            current={current}
            items={numberSteps}
            aria-label={accessibilityLabel || `Krok ${current} z ${stepsCount}`}
        />
    );

    return centered ? <Centered>{content}</Centered> : content;
};
